/* Núvo cart lab (DEV) — "Frequently Bought Together".
   Delegated so it survives drawer re-renders:
   - [data-fbt-add]  → add the variant via /cart/add.js (drawer refreshes/opens
     via nuvo-cart-open.js; gifts reconcile via nuvo-cart-rewards.js).
   - [data-fbt-prev] / [data-fbt-next] → scroll the mobile carousel one card. */
(function () {
  'use strict';
  if (window.__nuvoFbtInit) return;
  window.__nuvoFbtInit = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addToCart(btn) {
    if (btn.disabled) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { btn.textContent = 'Added ✓'; })
      .catch(function () { btn.textContent = 'Try again'; btn.disabled = false; });
  }

  function paginate(arrow, dir) {
    var wrap = arrow.closest('[data-fbt-carousel]');
    var track = wrap && wrap.querySelector('[data-fbt-track]');
    if (!track) return;
    var card = track.querySelector('.nuvo-fbt__card');
    var step = card ? card.offsetWidth : track.clientWidth;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-fbt-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    var prev = e.target.closest('[data-fbt-prev]');
    if (prev) { e.preventDefault(); paginate(prev, -1); return; }
    var next = e.target.closest('[data-fbt-next]');
    if (next) { e.preventDefault(); paginate(next, 1); return; }
  });
})();
